import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Coffee, Utensils, Star } from 'lucide-react';
const MENU_URL = 'https://smartmenu.agorapos.com/?id=7iud3xn2#/category/10';
const PASTRY_IMG = 'https://cdn.magicpatterns.com/uploads/4U4fJyuQ8CgT9NmnSttBc4/IMG_1805.jpg';
const COFFEE_IMG = 'https://cdn.magicpatterns.com/uploads/rUd9Y9dbtgDwdFCmjNpMD6/IMG_1821.jpg';
const featured = [{
  id: 0,
  name: 'Churro espiral con chocolate y M&Ms',
  category: 'Estrella',
  image: 'https://cdn.magicpatterns.com/uploads/drG4ovzY9Q4pegA384M7DP/IMG_1800.jpg',
  alt: 'Churro espiral artesano con chocolate y M&Ms'
}, {
  id: 1,
  name: 'Crepe de chocolate con fresas',
  category: 'Dulce',
  image: 'https://cdn.magicpatterns.com/uploads/nNfeL83K5ZUB4vhxjAePpy/Captura_de_pantalla_2026-05-15_a_las_17.00.49.png',
  alt: 'Crepe relleno y decorado con chocolate y fresas frescas'
}, {
  id: 2,
  name: 'Batido de chocolate',
  category: 'Bebida',
  image: 'https://cdn.magicpatterns.com/uploads/s36YfCQ2Cgaohfw5GXWvEw/Captura_de_pantalla_2026-05-15_a_las_17.01.08.png',
  alt: 'Batido de chocolate con nata montada y sirope'
}, {
  id: 3,
  name: 'Tosta de lomo asado',
  category: 'Tostas',
  image: 'https://cdn.magicpatterns.com/uploads/vQpb81hi1ET5r1SGvUR665/Captura_de_pantalla_2026-05-15_a_las_17.17.41.png',
  alt: 'Tosta con generosas láminas de lomo asado'
}, {
  id: 4,
  name: 'Tosta de salmón ahumado',
  category: 'Tostas',
  image: 'https://cdn.magicpatterns.com/uploads/kbXY3ZpBa4Tc438aUBHATq/IMG_1815.jpg',
  alt: 'Tosta de salmón ahumado con queso crema, lechuga y sésamo negro'
}, {
  id: 5,
  name: 'Tosta de huevos con aguacate',
  category: 'Tostas',
  image: 'https://cdn.magicpatterns.com/uploads/3o7c5ADnXrBrZQ6P478Mdg/IMG_1816.jpg',
  alt: 'Tosta con dos huevos sobre aguacate, lechuga y sésamo negro'
}, {
  id: 6,
  name: 'Tosta de salmón con huevo',
  category: 'Tostas',
  image: 'https://cdn.magicpatterns.com/uploads/5Axuy2dce6PD5vsiS932H5/IMG_1818.jpg',
  alt: 'Tosta con salmón ahumado, huevo, aguacate, tomate y lechuga'
}, {
  id: 7,
  name: 'Tortilla en pinchos',
  category: 'Para picar',
  image: 'https://cdn.magicpatterns.com/uploads/kMFsE5VnQj9EL1eED33rFJ/Captura_de_pantalla_2026-05-15_a_las_17.21.31.png',
  alt: 'Pinchos de tortilla española servidos con copa de vino y ensalada de anchoas'
}, {
  id: 8,
  name: 'Tabla de queso curado',
  category: 'Para picar',
  image: 'https://cdn.magicpatterns.com/uploads/iz3SyBsuKm7UCvEFS3tnUV/IMG_1813.jpg',
  alt: 'Tres porciones triangulares de queso curado servidas en plato sobre madera'
}, {
  id: 9,
  name: 'Gofre con chocolate',
  category: 'Dulce',
  image: 'https://cdn.magicpatterns.com/uploads/eMzMcJtdjFNe2sm58rkgX5/IMG_1823.jpg',
  alt: 'Gofre artesano bañado en chocolate sobre plato gris'
}, {
  id: 10,
  name: 'Crepe con helado y chocolate',
  category: 'Dulce',
  image: 'https://cdn.magicpatterns.com/uploads/44ZP6vZT6KVGfwrxFCMbe2/IMG_1822.jpg',
  alt: 'Crepe con helado, nata montada y sirope de chocolate'
}, {
  id: 11,
  name: 'Helados artesanos La Perla',
  category: 'Postres',
  image: 'https://cdn.magicpatterns.com/uploads/hXSTvpTatJ8zhCZ7p8o5ZM/IMG_1824.jpg',
  alt: 'Vitrina de helados artesanos La Perla con varios sabores'
}];
export function Menu() {
  return <div className="py-12 md:py-20" data-id="element-349">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-350">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-351">
          <motion.span initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-352">
            Nuestra carta
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-6xl font-serif text-cafe-primary mt-3 mb-6" data-id="element-353">
            Menú
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg text-cafe-text/80 mb-10" data-id="element-354">
            Descubre nuestros churros artesanos, crepes dulces, tostas, tapas
            para picar, batidos artesanos y nuestra cuidada carta de cafés.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-355">
            <a href={MENU_URL} target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-8 py-4 text-lg font-medium rounded-full text-white bg-cafe-primary hover:bg-cafe-accent transition-colors shadow-soft hover:shadow-lg transform hover:-translate-y-0.5 duration-200" data-id="element-356">
              Abrir menú completo <ExternalLink size={20} className="ml-2" data-id="element-357" />
            </a>
          </motion.div>
        </div>
        {/* Preview Section */}
        <div className="mt-20" data-id="element-358">
          <div className="text-center mb-12" data-id="element-359">
            <h2 className="text-2xl md:text-3xl font-serif text-cafe-primary flex items-center justify-center gap-3 flex-wrap" data-id="element-360">
              <Utensils size={22} className="text-cafe-accent" data-id="element-361" />
              Un vistazo a lo que ofrecemos
              <Coffee size={22} className="text-cafe-accent" data-id="element-362" />
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-363">
            {featured.map((item, i) => <motion.article key={item.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i % 3 * 0.08
          }} className="bg-white rounded-2xl overflow-hidden shadow-soft border border-cafe-border/50 group" data-id="element-364">
                <div className="aspect-square overflow-hidden relative" data-id="element-365">
                  <img src={item.image} alt={item.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-366" />
                  <div className="absolute top-4 left-4" data-id="element-367">
                    <span className={`inline-flex items-center gap-1.5 text-xs tracking-wider uppercase font-medium px-3 py-1.5 rounded-full shadow-sm ${item.category === 'Estrella' ? 'bg-cafe-primary text-white' : 'bg-white/95 backdrop-blur-sm text-cafe-primary'}`} data-id="element-368">
                      {item.category === 'Estrella' && <Star size={10} className="fill-current" data-id="element-369" />}
                      {item.category}
                    </span>
                  </div>
                </div>
                <div className="p-5 text-center bg-cafe-card/30" data-id="element-370">
                  <h3 className="text-lg font-serif text-cafe-primary leading-snug" data-id="element-371">
                    {item.name}
                  </h3>
                </div>
              </motion.article>)}
          </div>
        </div>
        {/* Café editorial block */}
        <div className="mt-20 bg-cafe-card/50 rounded-3xl overflow-hidden" data-id="element-372">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center" data-id="element-373">
            <div className="p-8 md:p-12 lg:p-14 text-center md:text-left order-2 md:order-1" data-id="element-374">
              <span className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium block mb-3" data-id="element-375">
                Café de especialidad
              </span>
              <h3 className="text-2xl md:text-3xl font-serif text-cafe-primary mb-4 leading-tight" data-id="element-376">
                Servido con <span className="italic" data-id="element-377">amor</span>
              </h3>
              <p className="text-cafe-text/70 leading-relaxed" data-id="element-378">
                Cada taza se prepara con mimo, desde el grano hasta el corazón
                que dibuja la espuma. Cafés de especialidad, latte, capuchino y
                mucho más.
              </p>
            </div>
            <div className="aspect-[4/5] md:aspect-square overflow-hidden order-1 md:order-2" data-id="element-379">
              <img src={COFFEE_IMG} alt="Dos tazas de café con latte art en forma de corazón junto a granos de café tostado" className="w-full h-full object-cover" data-id="element-380" />
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-8 bg-cafe-card/50 rounded-3xl overflow-hidden" data-id="element-381">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center" data-id="element-382">
            <div className="aspect-[4/5] md:aspect-square overflow-hidden" data-id="element-383">
              <img src={PASTRY_IMG} alt="Vitrina con repostería casera de Trastienda Café" className="w-full h-full object-cover" data-id="element-384" />
            </div>
            <div className="p-8 md:p-12 lg:p-14 text-center md:text-left" data-id="element-385">
              <Coffee size={32} className="text-cafe-accent mb-4 mx-auto md:mx-0" data-id="element-386" />
              <h3 className="text-2xl md:text-3xl font-serif text-cafe-primary mb-3" data-id="element-387">
                Y mucho más...
              </h3>
              <p className="text-cafe-text/70 mb-6 leading-relaxed" data-id="element-388">
                Cafés de especialidad, tés, infusiones, repostería casera y
                muchas otras opciones esperan en nuestra carta digital.
              </p>
              <a href={MENU_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-cafe-accent hover:text-cafe-primary font-medium underline underline-offset-4" data-id="element-389">
                Explora la carta completa
                <ExternalLink size={16} className="ml-2" data-id="element-390" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
}